import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { DELETE_MESSAGE } from "../../common/Constant";
import { toastSuccess } from "../../common/Toast";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Stack,
  TextField,
  Tooltip,
} from '@mui/material';

const DeleteConfirmation = ({ deleteApiUrl, open, onClose }) => {
  const handleSubmit = () => {
    //put your validation logic here
    const token = localStorage.getItem("Token");
    const deleteRequestParam = localStorage.getItem("DeleteRequestParam");

    axios
      .post(`${deleteApiUrl}`, deleteRequestParam, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then(() => {
        toastSuccess(DELETE_MESSAGE);
        window.location.reload()
      });

    onClose();
  };


  return (
    <Dialog open={open}>
      <DialogTitle textAlign="center">Confirmation</DialogTitle>
      <DialogContent>
        Are you sure you want to delete this record?
      </DialogContent>
      <DialogActions sx={{ p: '1.25rem' }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button style={{
          backgroundColor: '#FF9F43',
          color: 'white'
        }} onClick={handleSubmit} variant="contained">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );

  // return (
  //   <>
  //       // <div className="modal fade" id="DeleteConfirmationModal">
  //       //   <div className="modal-dialog modal-sm modal-dialog-centered">
  //       //     <div className="modal-content">
  //       //       <div className="modal-header">
  //       //         <h5 className="modal-title">Confirmation</h5>
  //       //         <button
  //       //           type="button"
  //       //           className="close"
  //       //           data-bs-dismiss="modal"
  //       //           aria-label="Close"
  //       //           onClick={() => setShowModal(false)}
  //       //         >
  //       //           <span aria-hidden="true">×</span>
  //       //         </button>
  //       //       </div>
  //       //       <div className="modal-body">
  //       //         <div className="row">
  //       //           <div className="col-lg-12">
  //       //             <h6>Are you sure you want to delete this record?</h6>
  //       //           </div>
  //       //         </div>
  //       //       </div>
  //       //       <div className="modal-footer justify-content-center">
  //       //         <Link
  //       //           to="#"
  //       //           className="btn btn-primary btn-md me-1"
  //       //           data-bs-dismiss="modal"
  //       //           onClick={handleDeletePopup}
  //       //         >
  //       //           Delete
  //       //         </Link>
  //       //         <Link
  //       //           to="#"
  //       //           className="btn btn-dark btn-md me-1"
  //       //           data-bs-dismiss="modal"
  //       //           onClick={() => setShowModal(false)} // Close the modal
  //       //         >
  //       //           Cancel
  //       //         </Link>
  //       //       </div>
  //       //     </div>
  //       //   </div>
  //       // </div>
  //   </>
  // );

};

export default DeleteConfirmation;
